.rasa-chat-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 73px;
  border-top: 1px solid var(--color-secondary-20);
  background-color: var(--input-background-color);

  &__input {
    margin: 24px;
    outline: none;
    border: none;
    width: 100%;
    background-color: transparent;
    color: var(--input-color);
    font-family: var(--font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.6px;

    @include placeholder {
      color: var(--input-placeholder-color);
      opacity: var(--input-placeholder-opacity);
      font-family: var(--font-family);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0.6px;
    }

    &:focus {
      outline: none;
    }
  }

  &__button {
    outline: none;
    border: none;
    cursor: pointer;
    background-color: transparent;
    display: flex;
    width: 73px;
    height: 73px;
    padding: 25px 24px 24px 25px;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    width: 23px;
    height: 23px;
    color: var(--input-send-color);
  }
}
